import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Trash } from "@phosphor-icons/react";

/**
 * Componente compartido de captura de firma manuscrita en pantalla.
 * onChange recibe el PNG en base64 (data:image/png;base64,...) o "" al limpiar.
 * Modo inline: no guarda automáticamente (a diferencia del de InspectionDetail.jsx),
 * el formulario padre decide cuándo enviar el valor al backend.
 */
export default function SignaturePad({ label, value, onChange, testid, compact }) {
    const ref = useRef(null);
    const clear = () => { ref.current?.clear(); onChange(""); };
    const capture = () => {
        if (!ref.current || ref.current.isEmpty()) return;
        const data = ref.current.getTrimmedCanvas().toDataURL("image/png");
        onChange(data);
    };
    return (
        <div data-testid={testid}>
            {label && <div className="overline mb-1.5">{label}</div>}
            {value ? (
                <div>
                    <img src={value} alt="firma" className={`w-full ${compact ? "h-20" : "h-32"} object-contain bg-zinc-50 border border-zinc-200`} />
                    <button type="button" onClick={() => onChange("")} className="text-xs text-red-500 hover:text-red-700 mt-1" data-testid={`${testid}-redo`}>Volver a firmar</button>
                </div>
            ) : (
                <>
                    <div className="border border-zinc-200 bg-white">
                        <SignatureCanvas
                            ref={ref}
                            penColor="#000"
                            canvasProps={{ className: "signature-canvas", style: { width: "100%", height: compact ? 80 : 128 }, "data-testid": `${testid}-canvas` }}
                            onEnd={capture}
                        />
                    </div>
                    <button type="button" onClick={clear} className="text-xs text-zinc-400 hover:text-zinc-600 mt-1 flex items-center gap-1" data-testid={`${testid}-clear`}>
                        <Trash size={12} /> Limpiar
                    </button>
                </>
            )}
        </div>
    );
}
